export const DEBUG = false // Make true to enable debug logging
export const DEFAULT_INTERVAL = 15000
export const NO_OP = () => {}
